import React from "react";
import { t } from '../../../i18n';
import queries from "../../../queries";
import { Mutation, Query } from "react-apollo";
import NeedAdmin from "../../NeedAdmin";
import {FormattedMessage} from "react-intl";
import {backEndUri} from '../../../config';
import PhotoboothCellStatsButton from "../PhotoboothCellStatsButton";
import PhotoboothCellPhotosZipButton from "../PhotoboothCellPhotosZipButton";

export default function ModernPhotoboothCellEditor({ cell, language }) {
    const [cellData, setCellData] = React.useState(cell);

    return (
        <Query query={queries.cells.photobooth_gif.get} variables={{ id: cell.id }}>
            {({ loading, error, data }) => {

                if (loading) return <p>{t('ui.common.loading')}</p>;
                if (error) return <p>Error: {error.message}</p>;
                if(data){
                    const { photoboothGifCell } = data;
                    if (photoboothGifCell) {
                        setCellData(photoboothGifCell);
                    }
                }
                if (!cellData) return null;

                return (
                    <Mutation
                        refetchQueries={[{ query: queries.cells.photobooth_gif.get, variables: { id: cell.id } }]}
                        mutation={queries.cells.photobooth_gif.update}
                    >
                        {(updateCell, { loading: mutationLoading, error: mutationError }) => (
                            <>
                                {mutationError && <p>Error: {mutationError.message}</p>}
                                <input
                                    type="checkbox"
                                    checked={cellData.send_email}
                                    onChange={(e) =>
                                        setCellData({ ...cellData, send_email: e.target.checked })
                                    }
                                />
                                <button
                                    className="tsk-button"
                                    onClick={() => {
                                        updateCell({
                                            variables: {
                                                input: cellData,
                                            },
                                        });
                                    }}
                                >
                                    Update
                                </button>
                                <PhotoboothCellStatsButton cell={cellData} />
                                <PhotoboothCellPhotosZipButton cell={cellData} />
                            </>
                        )}
                    </Mutation>
                );
            }}
        </Query>
    );
}
